export default {
      id: "edit-icon-primary-usage",
      viewBox: "0 0 18 12",
      url: __webpack_public_path__ + "sprite.svg#edit-icon-primary-usage",
      toString: function () {
        return this.url;
      }
    }